import { Banner } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

export const MultipleProductsErrorBanner = ({ fetchErrorCode }) => {
	const { t } = useTranslation()

	if (!fetchErrorCode) {
		return ""
	}

	return (
		<div style={{ marginTop: "1rem" }}>
			<Banner
				status="critical"
				title={t(
					"multiple.couldnt_obtain_products_from_the_urls_provided",
				)}
			>
				{fetchErrorCode.includes("multilink") ? (
					<>
						<p>
							{t(
								"multiple.check_that_the_links_entered_are_valid",
							)}
						</p>
						<p>
							{t(
								"multiple.check_that_the_links_entered_are_from_public",
							)}
						</p>
					</>
				) : (
					<>
						<p>
							{t(
								"multiple.check_that_the_store_collection_entered_is_public_shopify_store",
							)}
						</p>
						<p>{t("multiple.store_or_store_collection")}</p>
					</>
				)}
				<p style={{ fontSize: "0.7rem", color: "#999" }}>
					{fetchErrorCode}
				</p>
			</Banner>
		</div>
	)
}
